import React from 'react';
import { BillingCustomerDetailStatus, ProjectBillingStatusDetail } from '../../constants';
import { Link } from 'react-router-dom';
import { Currency } from 'shared/components/Transactions/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTurnDownLeft, faTrash, faX } from '@fortawesome/pro-solid-svg-icons';

const ProjectRowResult = ({ project, month, year, item, handleDeleteProject, handleDeleteSubscriber }) => {
  const handleClick = () => {
    if (item.projectDetails.length === 1) {
      handleDeleteSubscriber(item.billingCustomerDetailId, item.displayName);
    } else {
      handleDeleteProject(item.billingCustomerDetailId, project.id, project.projectName, item.displayName);
    }
  };
  const ProjectReferenceStatus = ({ project }) => {
    switch (project.status) {
      case ProjectBillingStatusDetail.InAnotherBillingForGivenPeriod:
        return (
          <Link className="project-link" to={`/admin/invoices/${month}/${year}/${project.previousBillingId}`}>
            <FontAwesomeIcon className="mr-1" icon={faArrowTurnDownLeft} /> View
          </Link>
        );
      case ProjectBillingStatusDetail.OtherBillingReferenceRemoved:
        return (
          <div className="project-old-link">
            <FontAwesomeIcon className="mr-1" icon={faX} /> View
          </div>
        );
      default:
        return <div />;
    }
  };

  const InvoiceGeneratedBoolean = ({ project }) => {
    switch (project.status) {
      case ProjectBillingStatusDetail.InvoiceGenerated:
      case ProjectBillingStatusDetail.InvoiceFinalized:
        return (
          <>
            <div className="text-right">
              <Currency amount={project.allocationCost}></Currency>
            </div>
            <div className="text-right">
              <Currency amount={project.utilityCredit}></Currency>
            </div>
            <div className="text-right">
              <div>{project?.allocationAmount.toFixed(4)}</div>
            </div>
          </>
        );
      default:
        return (
          <>
            <div className="text-right" />
            <div className="text-right" />
            <div className="text-right" />
          </>
        );
    }
  };
  return (
    <div
      className={`project-table-results ${
        project.status === ProjectBillingStatusDetail.OtherBillingReferenceRemoved ? 'project-old-reference' : ''
      }`}
      key={project.id}
    >
      <Link to={`/admin/projects/${project.projectId}`}>{project.projectName}</Link>
      <ProjectReferenceStatus project={project} />
      <InvoiceGeneratedBoolean project={project} />
      <div className="text-right">
        {item.status === BillingCustomerDetailStatus.ReadyForInvoiceGeneration ||
        item.status === BillingCustomerDetailStatus.InAnotherBillingForGivenPeriod ? (
          <FontAwesomeIcon icon={faTrash} className="trash mr-2" onClick={handleClick} />
        ) : null}
      </div>
    </div>
  );
};

export default ProjectRowResult;
